/**
 * Nuture Track — camada de tracking de funil (GA4 select_promotion/view_promotion + UTM).
 *
 * Por que existe:
 *  - O Shopify Analytics não rastreia clique em CTA e perde a origem no handoff
 *    listicle/advertorial → /pages/free-d3k2 (nova aba abre 2ª sessão).
 *  - GA4 (gtag) e Triple Whale (TriplePixel) estão no window do tema → dá pra
 *    disparar direto. Meta/TikTok rodam em custom pixel (sandbox) → ficam de fora.
 *
 * O que faz:
 *  1. UTM: captura os parâmetros na aterrissagem e propaga pros links de handoff,
 *     pra sessão da free-d3k2 herdar a origem do ANÚNCIO (não virar "veio da listicle").
 *  2. select_promotion (evento recomendado do GA4): dispara no clique de CTA de funil.
 *  3. view_promotion: dispara quando o CTA entra na tela (1x por promoção/página).
 *  Sinks: gtag (GA4) + dataLayer + TriplePixel (Triple Whale) + Shopify.analytics.publish
 *  (barato, pro dia em que um custom pixel repassar pro Meta/TikTok).
 *
 * CTA de funil = <a> que aponta pra um destino de FUNNEL_DESTINATIONS (auto-detect,
 * já que os CTAs são conteúdo autorado no admin) OU elemento marcado com
 * [data-promo] / [data-adv-cta]. Metadado explícito opcional: data-promo-name / data-promo-id.
 */
(function () {
  if (window.__nutureTrack) return;
  window.__nutureTrack = true;

  // Destinos de handoff do funil. Estender aqui se surgirem novas ofertas.
  var FUNNEL_DESTINATIONS = ['/pages/free-d3k2'];
  var UTM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_id',
    'fbclid',
    'ttclid',
    'gclid',
  ];
  var STORE_KEY = 'nt_attribution';

  function params(search) {
    try {
      return new URLSearchParams(search || window.location.search);
    } catch (_) {
      return new URLSearchParams();
    }
  }

  function pageHandle() {
    var p = window.location.pathname.replace(/\/+$/, '');
    return p.substring(p.lastIndexOf('/') + 1) || 'home';
  }

  function isFunnelHref(href) {
    if (!href) return false;
    try {
      var u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return false; // só mesmo domínio
      return FUNNEL_DESTINATIONS.some(function (d) {
        return u.pathname.indexOf(d) === 0;
      });
    } catch (_) {
      return false;
    }
  }

  function isTrackedCta(el) {
    if (!el) return false;
    return (
      el.hasAttribute('data-promo') ||
      el.hasAttribute('data-adv-cta') ||
      (el.tagName === 'A' && isFunnelHref(el.getAttribute('href')))
    );
  }

  // ---------- 1. Atribuição (UTM) ----------
  // Captura os UTMs da URL na aterrissagem; se a URL não trouxer nada, mantém o
  // que já foi guardado nesta aba (sobrevive à navegação interna).
  function captureAttribution() {
    var p = params();
    var incoming = {};
    var hasAny = false;
    UTM_KEYS.forEach(function (k) {
      var v = p.get(k);
      if (v) {
        incoming[k] = v;
        hasAny = true;
      }
    });
    if (hasAny) {
      try {
        sessionStorage.setItem(STORE_KEY, JSON.stringify(incoming));
      } catch (_) {}
      return incoming;
    }
    try {
      return JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
    } catch (_) {
      return {};
    }
  }
  var ATTR = captureAttribution();

  // Propaga a atribuição pro link de handoff: a free-d3k2 herda a origem do
  // anúncio, e nt_from marca qual listicle/advertorial mandou.
  function propagateAttribution(a) {
    try {
      var u = new URL(a.href, window.location.origin);
      Object.keys(ATTR).forEach(function (k) {
        if (!u.searchParams.has(k)) u.searchParams.set(k, ATTR[k]);
      });
      if (!u.searchParams.has('nt_from')) u.searchParams.set('nt_from', pageHandle());
      a.href = u.toString();
    } catch (_) {}
  }

  // ---------- 2. Metadados da promoção ----------
  function promoData(el, slot) {
    var text = (el.getAttribute('data-promo-name') || el.getAttribute('data-adv-cta') || el.textContent || '')
      .trim()
      .replace(/\s+/g, ' ')
      .slice(0, 100);
    var handle = pageHandle();
    var id =
      el.getAttribute('data-promo-id') ||
      (handle + '_' + (text || 'cta'))
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_|_$/g, '')
        .slice(0, 100);
    return {
      creative_name: text || 'cta',
      creative_slot: handle + '#' + slot,
      promotion_id: id,
      promotion_name: (handle + ' — ' + (text || 'cta')).slice(0, 100),
      location_id: window.location.pathname,
    };
  }

  // ---------- 3. Sinks ----------
  function emit(eventName, promo) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', eventName, promo);
    } catch (_) {}
    try {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: eventName, promotion: promo });
    } catch (_) {}
    try {
      if (typeof window.TriplePixel === 'function') window.TriplePixel('custom', eventName, promo);
    } catch (_) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, promo);
      }
    } catch (_) {}
  }

  // ---------- 4. Instrumentar ----------
  function collectCtas() {
    var out = [];
    document.querySelectorAll('a[href], [data-promo], [data-adv-cta]').forEach(function (el) {
      if (isTrackedCta(el)) out.push(el);
    });
    return out;
  }

  function indexOf(arr, el) {
    for (var i = 0; i < arr.length; i++) if (arr[i] === el) return i + 1;
    return 0;
  }

  function init() {
    var ctas = collectCtas();
    var viewedIds = {};

    var io =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (e) {
                if (!e.isIntersecting) return;
                var promo = promoData(e.target, indexOf(ctas, e.target));
                if (!viewedIds[promo.promotion_id]) {
                  viewedIds[promo.promotion_id] = true;
                  emit('view_promotion', promo);
                }
                io.unobserve(e.target);
              });
            },
            { threshold: 0.5 },
          )
        : null;

    ctas.forEach(function (el) {
      if (el.tagName === 'A' && isFunnelHref(el.getAttribute('href'))) propagateAttribution(el);
      if (io) io.observe(el);
    });

    // Clique delegado (capture) — dispara antes da navegação; gtag/TW usam
    // sendBeacon, então o evento sobrevive ao unload.
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var el = t.closest('a[href], [data-promo], [data-adv-cta]');
        if (!isTrackedCta(el)) return;
        emit('select_promotion', promoData(el, indexOf(collectCtas(), el)));
      },
      true,
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
